import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { authAPI } from '../services/api';

function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== passwordConfirm) {
      setError('비밀번호가 일치하지 않습니다.');
      return;
    }

    setLoading(true);
    try {
      await authAPI.resetPassword(token, password);
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || '비밀번호 변경에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card card">
        <h1>keunson</h1>
        <p>새 비밀번호를 설정하세요</p>

        {!token ? (
          <>
            <div className="error-msg">유효하지 않은 접근입니다. 메일의 재설정 링크로 다시 접속해주세요.</div>
            <p style={{ textAlign: 'center', marginTop: 16, color: '#8B8B9E' }}>
              <Link to="/find-account?tab=password">비밀번호 찾기로 이동</Link>
            </p>
          </>
        ) : done ? (
          <div style={{ textAlign: 'center', padding: '12px 0' }}>
            <p style={{ color: '#00D2D3', lineHeight: 1.6 }}>
              비밀번호가 변경되었습니다.<br />새 비밀번호로 로그인해주세요.
            </p>
            <Link to="/login" className="btn btn-primary" style={{ marginTop: 16, display: 'inline-block' }}>
              로그인하러 가기
            </Link>
          </div>
        ) : (
          <>
            {error && <div className="error-msg">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>새 비밀번호</label>
                <input
                  type="password"
                  className="form-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="8자 이상, 영문+숫자 포함"
                  required
                  minLength={8}
                />
              </div>

              <div className="form-group">
                <label>새 비밀번호 확인</label>
                <input
                  type="password"
                  className="form-input"
                  value={passwordConfirm}
                  onChange={(e) => setPasswordConfirm(e.target.value)}
                  placeholder="한 번 더 입력"
                  required
                />
              </div>

              <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
                {loading ? '변경 중...' : '비밀번호 변경'}
              </button>
            </form>

            <p style={{ textAlign: 'center', marginTop: 16, color: '#8B8B9E' }}>
              <Link to="/login">로그인으로 돌아가기</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default ResetPasswordPage;
